import * as React from 'react';
/**
 * The DayPicker context shares the props passed to DayPicker within the
 * internal components. It is used to set the default values and  perform
 * one-time calculations required to render the days.
 *
 * Access this context from the [[useDayPicker]] hook when using custom
 * components.
 */
export var DayPickerContext = React.createContext(undefined);
//# sourceMappingURL=DayPickerContext.js.map